"use client"; // Ensure this directive is present
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

const icons = ['fas fa-microphone', 'fas fa-calendar-alt', 'fas fa-users',   'fas fa-lightbulb', 'fas fa-network-wired', 'fas fa-microphone', 'fas fa-calendar-alt', 'fas fa-users',   'fas fa-lightbulb', 'fas fa-network-wired'];
 const wpUrl = process.env.REACT_APP_WP_URL;
export default function FeatureOne() {

     const [types, setTypes] = useState([]);
      useEffect(() => {
        fetch(`${wpUrl}wp-json/wp/v2/categories?parent=25`)
          .then(res => res.json())
          .then(data => {
           
            setTypes(data); 
          })
         
          .catch(err => console.error('Error fetching event types:', err));
      }, []);

      
    

    return (
        <section id="th-services" className="feature-one">
            <div className="container">
                <div className="section-title text-center">
                    
                    <h2 className="section-title__title">What We Do</h2>
                     <div className="section-title__tagline-box">
                        <span className="section-title__tagline">Discover and explore the wide variety of event types we offer, each thoughtfully 
                        curated to suit different interests, themes, and experiences—whether you're planning a night out, 
                        a family gathering, or a special celebration</span>
                        </div>
                </div>
               <div className="row">
                    {types.length === 0
                    ? Array.from({ length: 4 }).map((_, index) => (
                        <div key={index} className="col-xl-3 col-lg-6 col-md-6">
                            <div className="feature-one__single text-center placeholder-card">
                            <div className="placeholder-icon" />
                            <div className="placeholder-title" />
                            </div>
                        </div>
                        ))
                    : types.map((type, index) => (
                        <div key={type.id} className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft" data-wow-delay="500ms">
                            <div className="feature-one__single text-center d-flex flex-column align-items-center">
                            <Link to={`/event?event_type=${encodeURIComponent(type.slug || type)}`}>
                                <i className={`${icons[index % icons.length]} mb-3`} style={{ fontSize: '4rem' }}></i>
                                <h4 className="feature-one__title">{type.name}</h4>
                            </Link>
                            </div>
                        </div>
                        ))}

                    </div>

            </div>
        </section>
    );
}
